//var addFullAjaxTip, getAjaxTooltip, addFullTip, ajaxTip, getAjaxTooltipExcerpt, displayLoader ;

jQuery( document ).ready( function( $ ) {
	var isMobile = false; //initiate as false
	// device detection
	if ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test( navigator.userAgent ) ||
		 /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( navigator.userAgent.substr( 0, 4 ) ) ) {
		isMobile = true;
	}

	var $loading = $( '#loadingDiv' );
	$( document )
		.ajaxStart( function() {
		//$loading.show();
		} )
		.ajaxStop( function() {
		//$loading.hide();
		} );

	//alert(isMobile);

	//$( this ).append('<span class="fa fa-question-circle" ></span>');

	if ( isMobile = true ) {
		$( '.tooltip, .tip' ).each( function() {
			$( this ).tooltip( {
				items: '[title]',
				track: false,
				position: {
					my: 'left top',
					at: 'left top-50',
					collision: 'flipfit',
				},
			} );

			$( this ).click( function() {
				$( this ).tooltip( {
					items: '[title]',
					track: false,
					position: {
						my: 'left top',
						at: 'left top-50',
						collision: 'flipfit',
					},
				} );
				$( this ).tooltip( 'open' );
			} );
		} );
	} else {
		$( '.tooltip, .tip' ).each( function() {
			$( this ).tooltip( {
				track: false,
				position: {
					my: 'left top',
					at: 'left top-50',
					collision: 'flipfit',
				},
			} );
		} );
	}
	
	
	
	$( '.tip' ).each( function() {
		$( this ).html("test");
		$( this ).append( '<span class="fa fa-question-circle" ></span>' );
	} );

	$( '[data-ajaxtip]' ).each( function() {
		ajaxTip( $( this ) );
	} );

	//$( document ).tooltip({

	//window.addFullAjaxTip = addFullAjaxTip();

	$( '[data-fullajaxtip]' ).each( function() {
		addFullAjaxTip( $( this ) );
	} );

	//$( document ).tooltip({
	$( '[data-fulltip]' ).each( function() {
		addFullTip( $( this ) );
	} );

	$( '.modaltrigger' ).click( function() {
		//alert("goging");
		var tmpthing = $( this ).attr( 'data-target' );
		//alert(tmpthing);
		//$(tmpthing).hide();
		// $(tmpthing).fadeToggle( "slow", "linear" );
	} );
} );

/* END OF jQuerty READY */

//jQuery(function ($) {

window.getAjaxTooltip = function( post_id, element_id ) {
	jQuery.post( {
		type: 'post',
		timeout: 20000,
		url: ajax_object.ajax_url,
		//dataType: "json",
		data: {
			action: 'ps_get_page_content',
			id: post_id,
		},
		//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
		error: function( textStatus, textStatus2 ) {
			console.log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
		},
		success: function( response ) {
			//console.log('Got this from the server: ');
			//console.log(response );
			jQuery( document ).data( 'html_content_' + post_id, response );
			jQuery( '#' + element_id ).html( response );
			//return response;
		},
	} );
};

window.getAjaxTooltipExcerpt = function( post_id, element_id, data_id ) {
	console.log("got sent this:"+post_id+" "+element_id+" "+data_id+" ");
	jQuery( '#' + element_id ).html( "wtf?" );
	jQuery.post( {
		type: 'post',
		timeout: 20000,
		url: ajax_object.ajax_url,
		//dataType: "json",
		data: {
			action: 'ps_get_tooltip_excerpt',
			id: post_id,
		},
		//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
		error: function( textStatus, textStatus2 ) {
			console.log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
		},
		success: function( response ) {
			//console.log('Got this from the server: ');
			//console.log(response );
			console.log( data_id );
			jQuery( 'div.' + element_id ).html( response );
			
			jQuery( '#' + data_id ).data( 'fullajaxtip', response );
			//console.log("fullajaxtip_"+data_id );
			
			//return response;
		},
	} );
};

window.displayLoader = function( post_id, element_id ) {
	var output = '\
		<div class="loadingDiv">\
		<div class="loadingDiv_inner">\
		<img src="/wp-content/uploads/2016/05/logo.png"><br>\
		LOADING\
		<br>\
		<span class="fa fa-spinner fa-spin"></span>\
		</div>\
		</div>\
		';

	return output;
};

window.addFullTip = function( thisObj ) {
	$( thisObj ).append( '<span class="fa fa-question-circle" ></span>' );
	console.log( 'addFullTip going' );

	//$( document ).find('[data-desc]').each( function() {
	//console.log("found");
	$( thisObj.children().last() ).tooltip( {
		items: '[title],[data-fulltip]',
		track: false,
		position: {
			my: 'left top',
			at: 'left top-50',
			collision: 'flipfit',
		},
		content: function() {
			//  return "test";
			return $( this ).attr( 'title' ) + ' Click for more<div class="full_tooltip hide">' + $( this ).data( 'fulltip' ) + '</div>';
		},
		open: function( event, ui ) {
			if ( typeof( event.originalEvent ) === 'undefined' ) {
				return false;
			}

			var $id = $( ui.tooltip ).attr( 'id' );

			console.log( $( this ).find( '.full_tooltip' ).html() );

			// close any lingering tooltips
			$( 'div.ui-tooltip' ).not( '#' + $id ).remove();
			$( 'div.ui-tooltip' ).click( function() {
				var tmpdialogTitle = $( this ).find( '.full_tooltip' ).html();
				var tmpdialogContent = $( this ).data( 'name' );

				var myhtml = '\
					<p>\
					' + tmpdialogContent + '-\
					</p>\
					';
				$( '<div />' ).html( myhtml ).dialog( {
					modal: true,
					title: tmpdialogTitle,
					maxWidth: 10000,
					maxHeight: 10000,
					buttons: {
						Ok: function() {
							$( this ).dialog( 'close' );
						},
					},
				} );
			} );

			// ajax function to pull in data and add it to the tooltip goes here
		},
		close: function( event, ui ) {
			ui.tooltip.hover( function() {
				$( this ).stop( true ).fadeTo( 400, 1 );
			},
			function() {
				$( this ).fadeOut( '400', function() {
					$( this ).remove();
				} );
			} );
		},
	} );
};

window.addFullAjaxTip = function( thisObj ) {
	$( thisObj ).append( '<span class="fa fa-question-circle" ></span>' );
	
	var $id = Math.floor( ( Math.random() * 1000 ) + 1 );
	
	if(typeof($( thisObj ).attr( 'id' )) === 'undefined'){
		$( thisObj ).attr( 'id','tip_'+$id );
	}
	
	
	
	//$( document ).find('[data-desc]').each( function() {
	//console.log("found");
	$( thisObj.children().last() ).tooltip( {
		items: '[data-fullajaxtip]',
		track: false,
		position: {
			my: 'left top',
			at: 'left top-80',
			collision: 'flipfit',
		},
		content: function( event) {
			//  return "test";
			//console.log(event);
			//console.log(ui);
			//var $id = Math.floor( ( Math.random() * 1000 ) + 1 );
			/*
			console.log( $( this ).attr( 'id' ) );
			if(typeof($( this ).attr( 'id' )) === 'undefined'){
				$( this ).attr( 'id', $id+"_target")
			}
			*/
			console.log("%c%s", "color: #55ff55; font-size:30px;","continue");
			var num1 = $( this ).data( 'fullajaxtip' );
			if(isNaN(num1)){
				console.log($id + " is not a number <br/>");
				return $(thisObj).data("fullajaxtip");
			}//else{
			console.log( num1 + ' is a number' );
			//var tmpdialogExcerpt = getAjaxTooltipExcerpt($(this).data("fullajaxtip"));
			var this_tooltip = $( this );
			//var $id = Math.floor( ( Math.random() * 1000 ) + 1 );
			console.log( $id );
			var loadinghtml = '<div id="excerpt_' + $id + '" class="excerpt_' + $id + '"><span class="fa fa-spinner fa-spin"></span></div>';
			getAjaxTooltipExcerpt( $( this ).data( 'fullajaxtip' ), 'excerpt_' + $id, $( this ).attr( 'id' ) );
			console.log( $( this ).attr( 'id' ) );
			//}
			//var loadinghtml = '<div id="excerpt_' + $id + '"><span class="fa fa-spinner fa-spin"></span></div>';
			//getAjaxTooltipExcerpt($(this).data("fullajaxtip"),'excerpt_' + $id);
			return loadinghtml;

			/*				var tmpdialogExcerpt = getAjaxTooltipExcerpt($(this).data("fullajaxtip"));
			var this_tooltip = $( this );
			var $id = Math.floor((Math.random() * 1000) + 1);
			console.log($id);
			var loadinghtml = '<div id="excerpt_' + $id + '"><span class="fa fa-spinner fa-spin"></span></div>';
			getAjaxTooltipExcerpt($(this).data("fullajaxtip"),'excerpt_' + $id);
			return loadinghtml;
			 */

			//return getAjaxTooltipExcerpt($(this).data("fullajaxtip"));
			//return ' <span class="tooltip_title">' + $(this).attr("title") + '</span><br><span class="tooltip_more">Click for more info</span><span class="tooltip_width hide">500</span><div class="full_tooltip hide">' + $(this).data("fullajaxtip") + '</div>';
		},
		open: function( event, ui ) {
			if ( typeof( event.originalEvent ) === 'undefined' ) {
				return false;
			}
			var $element = $( event.target );
			var $id = $( ui.tooltip ).attr( 'id' );
			//console.log($( ui.tooltip ).attr( 'id' ));
			//console.log($id);
			// getAjaxTooltipExcerpt($(this).data("fullajaxtip"),'excerpt_' + $id);
			//console.log("test " + $(this).data("fullajaxtip"));
			//console.log("going --" + $(ui.tooltip).html() );
			// close any lingering tooltips
			var self = this;

			$( 'div.ui-tooltip' ).not( '#' + $id ).remove();

			$( 'div.ui-tooltip' ).click( function() {
				console.log( $( this ).text().indexOf( 'Click for more information' ) );
				if ( $( this ).text().indexOf( 'Click for more information' ) > -1 ) {
					var tmpdialogTitle = $( this ).find( 'span.tooltip_title' ).html();
					var tmpdialogContent = $( this ).data( 'name' );

					//var myhtml = getAjaxPage($(this).find('.full_tooltip').html());
					//console.log(myhtml );
					console.log( 'there is more' );
					//var $ajaxID = $(this).find('.full_tooltip').data("full_tooltip");
					var $ajaxID = $( ui.tooltip ).find( 'div.full_tooltip' ).html();
					//console.log('$ajaxID - ' + $(ui.tooltip).html() + $ajaxID);
					console.log( 'clicked' );
					var loadinghtml = '<div id="full_' + $id + '">' + displayLoader() + '</div>';

					var mywidth = 300;

					if ( $( this ).find( 'span.tooltip_width' ).html() ) {
						mywidth = $( this ).find( 'span.tooltip_width' ).html();
					}
					var this_tooltip = $( this );

					//var wWidth = $(window).width();
					//var dWidth = wWidth * 0.8;
					//var wHeight = $(window).height();
					//var dHeight = wHeight * 0.8;

					$( '<div />' ).html( loadinghtml ).dialog( {
						modal: true,
						title: tmpdialogTitle,
						resize: 'auto',
						width: mywidth,
						//height:dHeight,
						maxWidth: 10000,
						maxHeight: 10000,
						minHeight: 400,
						position: {
							my: 'center top',
							at: 'center top',
							of: this_tooltip,
						},
						buttons: {
							Close: function() {
								$( this ).dialog( 'close' );
							},
						},
						open: function() {
							//console.log($(document).data("fullajaxtip_"+data_id));
							console.log( 'GOING WITH -- ' + $ajaxID + '  full_' + $id );
							$( '#' + $id ).remove();
							var thiz = $( this );
							$( '.ui-widget-overlay' ).click( function() {
								$( thiz ).dialog( 'close' );
							} );

							if ( $( document ).data( 'html_content_' + $ajaxID ) ) {
								//console.log('yes');
								var tmp_loadcontent = jQuery( document ).data( 'html_content_' + $ajaxID );
								jQuery( '#full_' + $id ).html( tmp_loadcontent );
							} else {
								//console.log('no');
								getAjaxTooltip( $ajaxID, 'full_' + $id );
							}
						},
					} );
				} else {
					console.log( 'closing' );
					$( '#' + $id ).fadeOut( 400, function() {
						$( this ).remove();
					} ); //If there's no "click for more" just close the thing.
				}
			} );

			// ajax function to pull in data and add it to the tooltip goes here
		},
		close: function( event, ui ) {
			ui.tooltip.hover( function() {
				$( this ).stop( true ).fadeTo( 400, 1 );
			},
			function() {
				$( this ).fadeOut( '400', function() {
					$( this ).remove();
				} );
			} );
		},
	} );
};

//$( document ).tooltip({
window.ajaxTip = function( thisObj ) {
	//$( document ).find('[data-desc]').each( function() {
	//console.log("found");

	$( thisObj ).append( '<span class="fa fa-question-circle" ></span>' );

	$( thisObj.children().last() ).tooltip( {
		items: '[title],[data-ajaxtip]',
		track: false,
		position: {
			my: 'left top',
			at: 'left top-80',
			collision: 'flipfit',
		},
		content: function() {
			//  return "test";
			return ' <span class="tooltip_title">' + $( this ).attr( 'title' ) + '</span><br><span class="tooltip_more">Click for more info</span><span class="tooltip_width hide">500</span><div class="full_tooltip hide">' + $( this ).data( 'ajaxtip' ) + '</div>';
		},
		open: function( event, ui ) {
			if ( typeof( event.originalEvent ) === 'undefined' ) {
				return false;
			}

			var $id = $( ui.tooltip ).attr( 'id' );

			console.log( 'getting tooltip' );

			console.log( $( this ).find( '.full_tooltip' ).html() );

			// close any lingering tooltips
			$( 'div.ui-tooltip' ).not( '#' + $id ).remove();
			$( 'div.ui-tooltip' ).click( function() {
				var tmpdialogTitle = $( this ).find( 'span.tooltip_title' ).html();
				var tmpdialogContent = $( this ).data( 'name' );

				//var myhtml = getAjaxPage($(this).find('.full_tooltip').html());
				//console.log(myhtml );

				var ajaxID = $( this ).find( '.full_tooltip' ).html();
				var loadinghtml = '<div id="full_' + $id + '">' + displayLoader() + '</div>';

				var mywidth = 300;

				if ( $( this ).find( 'span.tooltip_width' ).html() ) {
					mywidth = $( this ).find( 'span.tooltip_width' ).html();
				}
				var this_tooltip = $( this );
				//var wWidth = $(window).width();
				//var dWidth = wWidth * 0.8;
				//var wHeight = $(window).height();
				//var dHeight = wHeight * 0.8;

				$( '<div />' ).html( loadinghtml ).dialog( {
					modal: true,
					title: tmpdialogTitle,
					resize: 'auto',
					width: mywidth,
					//height:dHeight,
					maxWidth: 10000,
					maxHeight: 10000,
					minHeight: 400,
					position: {
						my: 'center top',
						at: 'center top',
						of: this_tooltip,
					},
					buttons: {
						Close: function() {
							$( this ).dialog( 'close' );
						},
					},
					open: function() {
						$( '#' + $id ).remove();
						var thiz = $( this );
						$( '.ui-widget-overlay' ).click( function() {
							$( thiz ).dialog( 'close' );
						} );
						//getAjaxTooltip(ajaxID,'full_' + $id);

						if ( $( document ).data( 'html_content_' + ajaxID ) ) {
							//console.log('yes');
							var tmp_loadcontent = jQuery( document ).data( 'html_content_' + ajaxID );
							jQuery( '#full_' + $id ).html( tmp_loadcontent );
						} else {
							//console.log('no');
							getAjaxTooltip( ajaxID, 'full_' + $id );
						}
					},
				} );
			} );

			// ajax function to pull in data and add it to the tooltip goes here
		},
		close: function( event, ui ) {
			ui.tooltip.hover( function() {
				$( this ).stop( true ).fadeTo( 400, 1 );
			},
			function() {
				$( this ).fadeOut( '400', function() {
					$( this ).remove();
				} );
			} );
		},
	} );
};

//});

//export default{
//addFullAjaxTip
//};
